import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Utils from '../../../custom/utils';
import {API} from "../../../../config";
import _ from 'lodash';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import {connect} from "react-redux";
import FormControl from '@material-ui/core/FormControl';

const moment = require('moment');

const outbound = API.service('withdrawal');
const wallet = API.service('wallet');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        //border:'2px solid ' + theme.navigation.selected.backgroundColor,
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    },
    debutton:{
        padding:'5px 12px',
        //background:theme.navigation.selected.backgroundColor,
        //color:theme.navigation.selected.contrast,
        borderRadius:3,
        boxShadow:'2px 2px 2px #eee',

        '&:hover':{
            //background:theme.navigation.hover.backgroundColor,
            //color:theme.navigation.selected.contrast,
        }
    }
});

class InboundDepositRow extends Component {
    state={
        amountwithdrawn: this.props.row._amount,
        fee: this.props.row._fee,
        amount_expected: this.props.row._amount,
        _timestamp:null,
    };

    cancel = () => {
        const app = this;
        let payload = [
            {
                _account:this.props.row.investors[0]._account,
                _fund: parseFloat(this.props.row._amount) + parseFloat(this.props.row._fee),
                _comment:'Funds Released for Reversal of Withdrawal',
                _type: 'FUNDS-RELEASED',
                _reference_id:this.props.row._id,
                _currency: this.props.row._currency
            },
        ];
        wallet.create(payload).then(w=> {
            outbound.patch(app.props.row._id, {_status: 3}, {query: {$limit: 1, _id: app.props.row._id}}).then(o => {
                app.props.context.update({
                    popupContent: false,
                })
            });
        });
    }

    complete = () => {
        const app = this;
        let payload = [
            {
                _account:this.props.row.investors[0]._account,
                _fund: parseFloat(this.props.row._amount) + parseFloat(this.props.row._fee),
                _comment:'Funds Released for Withdrawal',
                _type: 'FUNDS-RELEASED',
                _reference_id:this.props.row._id,
                _currency: this.props.row._currency
            },
            {
                _account:this.props.row.investors[0]._account,
                _fund: 0 - parseFloat(this.state.amountwithdrawn),
                _comment:'Funds Withdrawal',
                _type: 'DEBIT-WITHDRAW',
                _reference_id:this.props.row._id,
                _currency: this.props.row._currency
            },
            {
                _account:this.props.row.investors[0]._account,
                _fund: 0 - parseFloat(this.state.fee),
                _comment:'Fee for Funds Withdrawal',
                _type: 'DEBIT-FEE',
                _reference_id:this.props.row._id,
                _currency: this.props.row._currency
            },
        ];

        wallet.create(payload).then(w=>{
            outbound.patch(app.props.row._id,{_status:4, _amount:parseFloat(this.state.amountwithdrawn), _fee: parseFloat(this.state.fee)}, {query:{$limit:1, _id: app.props.row._id}}).then(o=>{
                app.props.context.update({
                    popupContent: false,
                })
            });
        });
    };

    handleChange = (event) => {
        this.setState(_.set({ ...this.state, error: '' }, event.target.id, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
    }

    close = () =>{
        this.props.context.update({
            popupContent: false,
        })
    };

    render() {
        const {classes} = this.props;
        let currency = Utils.getCurrency(this.props.row._currency.toUpperCase());

        let amnt = this.props.row._amount;

        return (
            <React.Fragment>
                <h3>Investor Details</h3>
                <b>Investor:</b> {this.props.row.investors[0]._firstname} {this.props.row.investors[0]._surname}<br />
                <b>Account:</b> {this.props.row.investors[0]._account}<br /><br />

                <div>
                    <h4>Bank Account Details</h4>
                    <b>Name:</b> {this.props.row._bank_account_name}<br />
                    <b>Number:</b> {this.props.row._bank_account_number}<br />
                    <hr />
                    <h4>Bank Details</h4>
                    <b>Name:</b> {this.props.row._bank_name}<br />
                    <b>SWIFT:</b> {this.props.row._bank_code}<br />
                    <b>City:</b> {this.props.row._bank_city}<br />
                    <b>State:</b> {this.props.row._bank_state}<br />
                    <b>Country:</b> {this.props.row._bank_country}
                </div>
                <hr />
                <b>Withdrawal Amount:</b> {currency.currency_symbol}{Utils.addThousandCommas(amnt, '0,0.00')}<br />
                <b>Fee Allocated:</b> {currency.currency_symbol}{Utils.addThousandCommas(this.props.row._fee, '0,0.00')}<br />
                <b>Total Frozen:</b> {currency.currency_symbol}{Utils.addThousandCommas((parseFloat(this.props.row._fee) + parseFloat(amnt)), '0,0.00')}

                <br /><br />
                <FormControl className={classes.formControl}>
                    <TextField
                      id="_timestamp"
                      name="_timestamp"
                      label="Withdrawal Date & Time"
                      type="datetime-local"
                      className={classes.textField}
                      value={this.state._timestamp}
                      onChange={this.handleChange}
                      margin="normal"
                      defaultValue={moment().format('YYYY-MM-DDTHH:MM')}
                    />
                </FormControl>
                <br />
                <TextField
                  id="amountwithdrawn"
                  label="Amount Sent"
                  className={classes.textField}
                  value={this.state.amountwithdrawn}
                  onChange={this.handleChange}
                  margin="normal"
                />
                <br />
                <TextField
                  id="fee"
                  label="Fee of"
                  className={classes.textField}
                  value={this.state.fee}
                  onChange={this.handleChange}
                  margin="normal"
                />
                <br />
                {(Utils.isEmpty(this.props.user.affiliate)) &&
                    <Button variant="contained" color="secondary" onClick={this.complete}>
                        Complete
                    </Button>
                }
                &nbsp;
                <Button variant="outlined" color="secondary" onClick={this.cancel}>
                    Cancel
                </Button>
                &nbsp;
                <Button variant="outlined" color="secondary" onClick={this.close}>
                    Close
                </Button>
            </React.Fragment>
        )
    }
}
function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(InboundDepositRow))));
